import { useWishlist } from '@context/WishlistContext'
import styles from '@styles/ProductCard.module.css'
import { ShoppingCart, Heart } from 'lucide-react'
import useFormatPrice from '@hooks/useFormatPrice'
import { useCart } from '@context/CartContext'
import Popup from '@components/Popup'
import PropTypes from 'prop-types'
import { useState } from 'react'

const ProductCard = ({ id, image, brand, reference, price, active, isFirstImage, isLens }) => {
  const { addToWishlist, removeFromWishlist, isInWishlist } = useWishlist()
  const [showPopup, setShowPopup] = useState(false)
  const formatPrice = useFormatPrice()
  const { addToCart } = useCart()

  if (!active) return null

  const handleWishlistToggle = e => {
    e.preventDefault()
    isInWishlist(id) ? removeFromWishlist(id) : addToWishlist({ id, image, brand, reference, price })
  }

  const handleAddToCart = e => {
    e.preventDefault()
    addToCart({ id, image, brand, reference, price })
    setShowPopup(true)
    setTimeout(() => setShowPopup(false), 3000)
  }

  return (
    <>
      <a className={styles.cardLink} href={`/producto/${id}`}>
        <div className={`${isLens ? styles.lensCard : styles.card}`} data-is-lens={isLens}>
          <div className={`${isLens ? styles.lensImageContainer : styles.imageContainer}`}>
          <img
              src={image}
              loading={isFirstImage ? 'eager' : 'lazy'}
              alt={`${brand} ${reference}`}
              className={isLens ? styles.lensImage : ''}
            />
            { isLens ? (<></>) : (
              <button
              className={`${styles.wishlistButton} ${ isInWishlist(id) ? styles.active : '' }`}
              onClick={handleWishlistToggle}
              aria-label={isInWishlist(id) ? 'Quitar de la lista de deseos' : 'Agregar a la lista de deseos'}
            >
              <Heart className={styles.heartIcon} />
            </button>
            ) }
          </div>
          <div className={styles.details}>
            <h3 className={styles.brand}>{brand}</h3>
            <p className={styles.reference}>{reference}</p>
            <div className={styles.priceContainer}>
              <span className={styles.price}>{formatPrice(price)}</span>
              <button className={styles.addButton} onClick={handleAddToCart} aria-label='Agregar al carro' >
                <ShoppingCart className={styles.cartIcon} />
                <span className={styles.addText}>Agregar</span>
              </button>
            </div>
          </div>
        </div>
      </a>
      {showPopup && (<Popup message='Producto agregado a tu carrito de compras' />)}
    </>
  )
}

ProductCard.propTypes = {
  id: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  reference: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
  isFirstImage: PropTypes.bool,
  isLens: PropTypes.bool
}

export default ProductCard
